{
  "slug": "mensa-iq-requirements",
  "title": "Mensa IQ 要求解释",
  "description": "了解Mensa资格如何使用前2%的,为什么合格数字因测试而异,以及为什么在线分数不是录取证据.",
  "summary": "Mensa 用百分比来描述资格:合格的成绩必须在或高于. 98智商是指在经过批准、适当监督的智力测试中,智商的第十个百分位数。",
  "category": "比较",
  "sections": [
    {
      "heading": "要求是百分比，而不是一个通用数字",
      "paragraphs": [
        "国际门萨组织声明,其成员资格对在经过适当管理和监督的核准智力测试中在一般人口中排名前2%的人开放。",
        "神秘的女孩 98100%的百分比通常接近 130 一个平均的100, SD- 无法确定15 虽然这些测试都使用了同样的标准偏差,但其他测试使用了不同的标准偏差、分数类型和截止值。"
      ]
    },
    {
      "heading": "提供合格结果的方法",
      "paragraphs": [
        "根据国家Mensa组织,候选人可以参加管理的入学考试或提交来自其他批准的评估证据。 程序,年龄限制,接受的文书和文件因国家而异。",
        "如果考试目的是获得资格,请在安排外部考试之前联系相关的Mensa办公室。"
      ]
    },
    {
      "heading": "实践和在线测试可以做什么",
      "paragraphs": [
        "练习题可以帮助人们理解格式和时间,但并不能证明合格,反复接触可能会提高熟悉度,而不是衡量总体能力的稳定变化。",
        "国际门萨会表示,在线测试不能用于入学,在线测试结果应被视为教育性或指示性的,除非接收组织明确表示相反。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "您需要什么智商分数才能进入Mensa?",
      "answer": "资格是基于. 98等效数字因测试尺度而异。"
    },
    {
      "question": "我可以用在线智商测试结果加入Mensa吗?",
      "answer": "Mensa International 声明,在线测试不能用于录取。"
    }
  ],
  "related": ["iq-test-vs-mensa-test", "what-is-considered-a-high-iq", "iq-percentiles"],
  "sources": [
    {
      "label": "Mensa国际 — 让你的智商测试",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
